import { jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { SEMANTIC } from '../tokens/color.js';
import { RADIUS } from '../tokens/radius.js';
import { rem, TYPE } from '../tokens/type.js';
/**
 * A small tinted label for the few states that earn a fill — consent, priority, billing
 * status, tenant status (§3 "Consent and priority use tinted tags"). Always carries text:
 * the tone is never the only signal. Free-form labels use the neutral tone. Lifecycle and
 * deal stages use `StagePill`, not this.
 */
export function Badge({ tone = 'neutral', label, icon, }) {
    return (_jsxs(Box, { component: "span", "data-tone": tone, sx: (t) => {
            const pair = tone === 'neutral' ? null : SEMANTIC[t.palette.mode][tone];
            return {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                height: 20,
                px: 0.875,
                borderRadius: `${RADIUS.sm - 1}px`,
                fontSize: rem(TYPE.micro.size),
                fontWeight: 500,
                lineHeight: 1,
                whiteSpace: 'nowrap',
                color: pair ? pair.fg : t.palette.text.secondary,
                bgcolor: pair ? pair.bg : t.palette.background.sidebar,
                border: pair ? '1px solid transparent' : `1px solid ${t.palette.hairline}`,
                '& svg': { fontSize: 12 },
            };
        }, children: [icon, label] }));
}
//# sourceMappingURL=badge.js.map